export default __webpack_public_path__ + "static/media/Image-6.329e8e42.png";